// export const BASEURL = process.env.REACT_APP_BASEURL
// export const APIURL = process.env.REACT_APP_APIURL
// export const BASEURL = "http://localhost:5007"
// export const APIURL = "http://localhost:5007/api"
export const BASEURL = "http://103.143.171.243:86";
export const APIURL = "http://103.143.171.243:86/api";
// export const BASEURL = "https://api.satudata.mubakab.go.id"
// export const APIURL = "https://api.satudata.mubakab.go.id/api"
